import { OfficeToolsFormEventHandlers } from '../../../../SingleGridForm/office-form/models/event-handler.model';
import { BeforeTabChangeEventHandler } from './before-tab-change-event.handler';
import { OfficeToolsEventsEnum } from '@pages/office/models/office-tools-events.model';

export const PREarnCode: OfficeToolsFormEventHandlers = {
  [OfficeToolsEventsEnum.BeforeTabChange]: BeforeTabChangeEventHandler,
};
